import { useState } from "react";
import { CustomButton } from "../../components/customButton/CustomButton";
import { CustomInput } from "../../components/customInput/CustomInput";
import { BlackClear, Review } from "../../resources/assetsManager";
import { SIDEBAR_COLOR, WHITE_COLOR } from "../../resources/colorsManager";
import FileDrop from "./FileDrop";

const ProductionModalBody = ({ closeModal, onSuccess }) => {
  const [step, setStep] = useState(0);

  return (
    <div
      style={{
        width: "30%",
        minWidth: "400px",
        backgroundColor: WHITE_COLOR,
        padding: "20px 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: "30px",
        position: "relative",
      }}
    >
      {step === 0 ? (
        <>
          <p
            style={{
              color: "black",
              fontSize: "22px",
              margin: "10px 0px 30px 0px",
            }}
            className="roboto"
          >
            {" "}
            Production Mode
          </p>

          <div
            style={{
              backgroundColor: "#E5E5E5",
              width: "36px",
              height: "36px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              right: "30px",
              top: "25px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() => {
              closeModal();
            }}
          >
            <img src={BlackClear} alt="Clear" />
          </div>

          <FileDrop label="Test Case" />

          <div style={{ width: "100%", marginTop: "10px" }}>
            <p
              style={{
                color: "black",
                fontSize: "14px",
                margin: "0px",
                marginBottom: "5px",
                marginLeft: "5px",
              }}
              className="roboto"
            >
              {"App Review"}
            </p>
            <CustomInput
              placeholder="App Url"
              inputStyles={{
                backgroundColor: "#F3F3F3",
                border: "0px",
                height: "56px",
                borderRadius: "3px",
                color: "#5C5C5C",
                width: "100%",
                padding: "0px 15px",
                boxSizing: "border-box",
                fontSize: "16px",
              }}
            />
          </div>

          <FileDrop label="Sign Off" style={{ marginTop: 10 }} />
          <CustomButton
            onClick={() => {
              setStep(1);
              onSuccess();
            }}
            title="Upload"
            styles={{
              backgroundColor: SIDEBAR_COLOR,
              border: "0px solid",
              borderRadius: "3px",
              width: "100%",
              height: "50px",
              marginTop: "15px",
              marginBottom: "15px",
            }}
          />
        </>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <img src={Review} style={{ objectFit: "contain" }} alt="Review" />

          <p style={{ color: "black", textAlign: "center" }} className="roboto">
            Our team will review and get back to you with in 7 working days
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductionModalBody;
